import { FormControl, FormControlProps, FormHelperText } from '@chakra-ui/react';
import FieldErrorMessage from './FieldErrorMessage';

export interface InputFormControlProps extends FormControlProps {
  message?: string;
  errorMessage?: string;
}

/**
 * @description
 * This is to wrap all input components for use in a form.
 */
export default function InputFormControl({
  message,
  errorMessage,
  ...props
}: InputFormControlProps) {
  return (
    <FormControl {...props}>
      {props.children}
      {message && <FormHelperText>{message}</FormHelperText>}
      {errorMessage && <FieldErrorMessage>{errorMessage}</FieldErrorMessage>}
    </FormControl>
  );
}
